interface Props {
  title: string
  eyebrow?: string
}

export default function PageHeader({ title, eyebrow }: Props) {
  return (
    <header className="page-header">
      {eyebrow && (
        <p className="page-eyebrow">{eyebrow.replace(/-/g, ' ')}</p>
      )}
      <h1>{title}</h1>
    </header>
  )
}
